<template>
    <mySubPage>
        <div slot="header">
            <myNav>修改密码</myNav>
            <div class="sn-info-box">
                <el-row>
                    <el-col :span="12">
                        {{$t('user_code')}}{{$t('x_mh')}}<span class="f-blue">{{user_code}}</span>
                    </el-col>
                    <el-col :span="12">
                        {{$t('user_cname')}}{{$t('x_mh')}}<span class="f-blue">{{user_cname}}</span>
                    </el-col>
                </el-row>
            </div>
        </div>
        <el-form class="pd-10" ref="form" :model="formData" :rules="rule" label-width="130px">
            <el-form-item :label="$t('new_pwd')" prop="user_pwd">
                <el-input v-model="formData.user_pwd" :placeholder="$t('input')" type="password"></el-input>
            </el-form-item>
            <el-form-item :label="$t('chk_pwd')" prop="chk_pwd">
                <el-input v-model="formData.chk_pwd" :placeholder="$t('input')" type="password"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <div class="flex-box bg-f8">
                <div class="flex-box-bd"></div>
                <el-button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</el-button>
                <el-button type="primary" @click="submit">{{$t('save')}}</el-button>
            </div>
        </div>
    </mySubPage>
</template>

<script>
    export default {
        data:function(){
            return{
                relist: false,
                formData: {
                    u_id:'',
                    user_pwd: '',
                    chk_pwd: ''
                },
                user_code:'',
                user_cname:'',
                rule: {
                    user_pwd: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    chk_pwd: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                }
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            var para = this.$base.getRequest();
            this.formData.u_id = para.id;
            this.user_code = para.user_code;
            this.user_cname = para.user_cname;
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            submit: function(){
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        if(this.formData.chk_pwd != this.formData.user_pwd) {
                            this.$base.alertErr(this.$t('user_pwd_err'));
                            return;
                        }
                        var data={
                            u_id: this.formData.u_id,
                            user_pwd: this.$base.toMD5(this.formData.user_pwd)
                        }
                        this.$base.showLoading();
                        this.$request.sendPost('user/set-pwd-by-manage',data,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.msgSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/user/user_reset_pwd.vue